import { ApplicationDataService } from './application.service'
import { RentableItem } from '../app/models/rentableitem';
import { environment } from '../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { AdditionalApplicationStepsInterface } from '../app/interface/additionalApplicationStepsInterface';
import { Bool } from 'aws-sdk/clients/clouddirectory';

@Injectable()
export class RentablesDataService {
    public static _API_ENDPOINT = environment.apiEndPoint;

    constructor(private http: HttpClient, private applicationService: ApplicationDataService) { }

    GetRentableItems(RentalApplicationKey: string) {
        return this.http.get<RentableItem[]>(RentablesDataService._API_ENDPOINT + 'Application/GetRentableItemsForApplication?RentalApplicationKey='
            + RentalApplicationKey, this.applicationService.createOptions())
            .pipe(
                catchError(this.applicationService.handleError),
                map((response) => <RentableItem[]>(response))
            );
    }

    GetPropertyHasRentableItems = (RentalApplicationKey: string, yardiKey: string) => {
        return this.http.get<AdditionalApplicationStepsInterface>(RentablesDataService._API_ENDPOINT + 'Application/GetPropertyHasRentableItems?RentalApplicationKey='
            + RentalApplicationKey + "&yardiKey=" + yardiKey, this.applicationService.createOptions())
            .pipe(
                catchError(this.applicationService.handleError),
                map((response) => <AdditionalApplicationStepsInterface>(response))
            );
    }

    UpdateRentableItems(rentalApplicantKey: number, rentalApplicationKey: number, rentableItems: RentableItem[]) {
        return this.http.post<RentableItem[]>(ApplicationDataService._API_ENDPOINT + 'Application/UpdateRentableItemsForApplication?RentalApplicationKey=' +
        rentalApplicationKey + '&RentalApplicantKey=' + rentalApplicantKey, rentableItems, this.applicationService.createOptions())
            .pipe(
                catchError(this.applicationService.handleError),
                map((response) => <RentableItem[]>(response))
            );
    }
}
